import getPricingData from '~/utils/pricing-table'

export const usePricingTable = () => {
  const { t } = useI18n()

  const plans = ref(getPricingData())

  const formatPrice = (amount: number, locale = 'de-DE') => {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
    }).format(amount)
  }

  const getPlanByName = (name: string) => {
    return plans.value.find(p => p.name === name)
  }

  const getPlans = () => {
    return plans.value
  }

  const isFeatured = (index: number) => {
    return index === 1 && plans.value.length === 3
  }

  return {
    plans,
    formatPrice,
    getPlanByName,
    getPlans,
    isFeatured
  }
}
